import request from "../request";

export class MasterDataService {
  
  static get = async () => {
    return await request.get(`/master_data`);
  };

}